var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2887"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 372",
    transform: "translate(0 -.001)",
    fill: "#fff",
    stroke: "#d8d8d8"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 22.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon feather-shopping-cart",
    fill: "none",
    stroke: "#97144d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3374",
    d: "M19.014 32.688a.941.941 0 11-.941-.941.941.941 0 01.941.941z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3375",
    d: "M29.365 32.688a.941.941 0 11-.941-.941.941.941 0 01.941.941z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3376",
    d: "M10.545 13.868h3.764l2.522 12.6a1.882 1.882 0 001.882 1.515h9.147a1.882 1.882 0 001.885-1.515l1.5-7.895h-16"
  })))));
}
export default SvgCart;